<template lang="pug">
.loader
  div
  div
  div
  div
  div
  div
  div
  div
</template>

<script>
export default {
  name: "loader",
};
</script>

<style lang="scss" scoped>
.loader {
  position: relative;
  display: inline-block;
  font-size: 10rem;
  width: 1em;
  height: 1em;
  margin: 0.333em auto;
  div {
    animation: loader 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    transform-origin: 0.5em 0.5em;
  }
  div:after {
    content: " ";
    display: block;
    position: absolute;
    width: 0.0875em;
    height: 0.0875em;
    border-radius: 50%;
    background: var(--loader-color);
    margin: -0.05em 0 0 -0.05em;
  }
  div:nth-child(1) {
    animation-delay: -0.036s;
  }
  div:nth-child(1):after {
    top: 0.7875em;
    left: 0.7875em;
  }
  div:nth-child(2) {
    animation-delay: -0.072s;
  }
  div:nth-child(2):after {
    top: 0.85em;
    left: 0.7em;
  }
  div:nth-child(3) {
    animation-delay: -0.108s;
  }
  div:nth-child(3):after {
    top: 0.8875em;
    left: 0.6em;
  }
  div:nth-child(4) {
    animation-delay: -0.144s;
  }
  div:nth-child(4):after {
    top: 0.9em;
    left: 0.5em;
  }
  div:nth-child(5) {
    animation-delay: -0.18s;
  }
  div:nth-child(5):after {
    top: 0.8875em;
    left: 0.4em;
  }
  div:nth-child(6) {
    animation-delay: -0.216s;
  }
  div:nth-child(6):after {
    top: 0.85em;
    left: 0.3em;
  }
  div:nth-child(7) {
    animation-delay: -0.252s;
  }
  div:nth-child(7):after {
    top: 0.7875em;
    left: 0.2125em;
  }
  div:nth-child(8) {
    animation-delay: -0.288s;
  }
  div:nth-child(8):after {
    top: 0.7em;
    left: 0.15em;
  }
}
@keyframes loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>